import { del, get } from "utils/OfflineUtil";
import store from "../redux-store/index";
import { getUserDataObjSuccess, setIsOffline } from "redux-store/slices/BusinessSlice";
import { calculateAndUpdateSale, checkCreateTicket, getParamsForSaleCalculate } from "./saleHelpers";
import { getAllTablesFn, getCatalogueDataFn, getCategoryDataFn, getDiscountsFn, getItemsFn, getMenuDataFn, getOptionSetsFn, isOffline } from "facade/ServiceFacade";
import { switchUserSuccess } from "redux-store/slices/LoginSlice";
import { updateOfflineLogin } from "redux-store/slices/GlobalSlice";
import { isEmpty } from "lodash";
import { saveSelectedChannelOffline } from "redux-store/slices/SaleSlice";
import moment from "moment";
import { getLocalStorage, setLocalStorage } from "utils";
import { LOCALSTORAGE_KEYS, SALE_PROCESS_OPERATION_TYPES, SALE_SYNC_STATUSES, TICKET_PRINT_STATUS_TYPES } from "utils/constants";

import { ToastNotifyError } from "commonComponents/ToastNotify";
import ObjectID from "bson-objectid";
import { arrayToMap } from 'helper/catalogueHelpers';
import { REST_SALE_BACK_ITEMS_NOT_PROCESSED } from 'data/constants'

export function setOffline(isOffline) {
  const businessStore = store.getState().businessStore,
    businessData = businessStore?.businessData || {};
  store.dispatch(setIsOffline({
    isOffline: isOffline,
    offlineTime: isOffline ? moment().tz(businessData?.timeZone?.zoneId || "Asia/Calcutta")?.format() : ""
  }))
  //   if (!isOffline) {
  //     store.dispatch(updateOfflineLogin({
  //       offlineLogin: false
  //     }))
  //   }
}

// ─── Moved to @rista/core/helpers/OfflineHelper ──────────────────────────────────────────
// `handleOfflineError`, `replaceLocalSale`, `saveOptionSetsOffline`, `putItemsOffline` and
// `saveOthersOffline` are identical in both apps and live in the folder's `shared.ts`;
// `updateSyncedSale` differs by its clone function and lives in `index.desktop.ts`.
// Re-exported so this file's importers are unchanged.
//
// ⚠️ `handleOfflineError` is IMPORTED as well as re-exported because this file still calls it
// 35 times in its own body — a bare `export { … } from` creates no local binding (ledger
// hazard 30). The other five have zero remaining references here (measured, strings and
// comments excluded), so they are re-exports only.
import { handleOfflineError } from "@rista/core/helpers/OfflineHelper";
export {
  handleOfflineError,
  updateSyncedSale,
  replaceLocalSale,
  saveOptionSetsOffline,
  putItemsOffline,
  saveOthersOffline,
  // uplifted 2026-09-15 for @rista/core/printing's offline KOT claim — identical in both apps
  updateAllTicketsPrintStatus,
} from "@rista/core/helpers/OfflineHelper";

// Updates synced sale


export function resetOfflineData() {
  del({
    domain: 'ITEM',
    callbackFn: (success, err) => {
      console.log('resetOfflineData __success');
    }
  })
}

// Moved to @rista/core/helpers/OfflineHelper.
//   shared.ts      -> fetchOthersOffline, filterRemoteStore, fetchTableOffline
//   index.desktop.ts -> getOptionsetOffline, getItemsOffline (they diverge by one dispatch:
//                     web adds optionSetsDataCallComplete/itemsDataCallComplete)
// Re-exported so this file's importers are unchanged. Nothing left in this file's own
// body calls any of the five (verified by the hazard-30 sweep after the move).
export {
  fetchOthersOffline,
  filterRemoteStore,
  fetchTableOffline,
  getOptionsetOffline,
  getItemsOffline,
} from "@rista/core/helpers/OfflineHelper";

export function loginOffline(ip, switchUser) {
  const offlineUserData = JSON.parse(getLocalStorage('offlineuser')) || []
  const offlineUserFromLocalStore = arrayToMap(offlineUserData, 'businessUserId');
  const offlineUserList = store.getState().loginStore?.offlineUsers || offlineUserFromLocalStore;
  const { uid, pin } = ip;
  const userData = store.getState().businessStore?.userData;
  const currentLicence = userData?.assignedLicence;
  let user = {};

  if (!uid || !pin) {
    // Throw error
    return;
  }
  if (isEmpty(offlineUserList)) {
    handleOfflineError("UI_ERR_OFFLINE_USER_NOT_FOUND");
    return;
  }
  user = offlineUserList[uid];
  if (!user) {
    handleOfflineError("UI_ERR_OFFLINE_USER_NOT_FOUND");
    return;
  }
  if (!user.oref) {
    handleOfflineError("UI_ERR_OFFLINE_PASSWORD_NOT_FOUND");
    return
  }

  if (!isEmpty(user.permittedLicences) && currentLicence && user.permittedLicences.indexOf(currentLicence) === -1) {
    handleOfflineError("UI_ERR_LICENCE_NOT_PERMITTED");
    return;
  }
  if (!validatePassword({ uid, pin, hash: user.oref })) {
    handleOfflineError("UI_ERR_INVALID_LOGIN_PARAMS"); 
    return
  }
  store.dispatch(getUserDataObjSuccess(user));
  user && setLocalStorage(LOCALSTORAGE_KEYS.USER_DATA, JSON.stringify(user));

  store.dispatch(updateOfflineLogin({
    offlineLogin: true
  }))

  ip.callback && ip.callback()

  clearOfflineRedux();
  if (!!switchUser) {
    store.dispatch(switchUserSuccess({
      offlineLogin: true
    }))
    return;
  }
  // Offline login success
  offlineloginSuccess();
}

export function offlineloginSuccess() {
  offlineReduxDBSync();
  offlineCatalogSetup();
}

export function validatePassword(ip) {
  const Hashes = require('jshashes');
  const MD5 = new Hashes.MD5;
  const { hash, pin, uid } = ip;

  return MD5.hex_hmac(uid, pin) === hash;
}

// Moved to @rista/core/helpers/OfflineHelper. Re-export only — this file's own body does not
// call it (checked, ledger rule 5). Per-variant in core: this platform's half ends with the host
// logout teardown, the other's does not.
export { logoutOffline } from "@rista/core/helpers/OfflineHelper";

export function offlineReduxDBSync() {
  try {
    getCatalogueDataFn();
    getItemsFn()
    getOptionSetsFn()
    getDiscountsFn()
    getMenuDataFn()
    getCategoryDataFn()
    getMenuDataFn()
  } catch (error) {
    console.log('Offline push to REDUX', error)
  }
}

function clearOfflineRedux() {
  // fetch offline tables
  getAllTablesFn();
}

function offlineCatalogSetup() {
  const defaultChannelForTakeNewOrder = store.getState().posSettingsStore?.defaultModuleSettings?.takeNewOrder?.defaultChannel || '';
  const channelData = store.getState().catalogStore?.channelData;
  let channel = null;

  channel = channelData?.find((channel) => {
    if (defaultChannelForTakeNewOrder === channel?.channelDefId)
      return channel;
  });
  if (channel) {
    store.dispatch(saveSelectedChannelOffline(channel));
  }
}

// Moved to @rista/core/helpers/OfflineHelper (2026-09-29, with the facade's customerSearch). Re-export only.
export { customerSearchOffline } from "@rista/core/helpers/OfflineHelper";

// Moved to @rista/core/helpers/OfflineHelper (2026-09-15, my-orders v2 detail). Re-export only.
export { saleCloseOffline } from "@rista/core/helpers/OfflineHelper";


export function fetchResourceOrdersOffline(params) {
  let filteredSaleVos = [];

  get({
    domain: 'SALE',
    filter: {
      name: 'ORDER_RESOURCE',
      resourceId: params.resourceId,
      params: {
        resourceId: params.resourceId
      }
    },
    callbackFn: (saleVos, error) => {
      if (error) {
        // Ext.Msg.alert('', Rista.MessageUtil.getMessage(error));
        return;
      }
      if (!isEmpty(saleVos)) {
        saleVos.forEach((item) => {
          filteredSaleVos.push(JSON.parse(item));
        });
        if (params.cb) {
          params.cb(filteredSaleVos);
        }
      }
    }
  });
}


// Moved to @rista/core/helpers/OfflineHelper and CONVERGED onto web's body: the two copies
// differed only in reading saleutil off a global (now IMPORTED, per the rista-library rule),
// a commented-out deviceIdentifier line on mobile, and an unguarded deviceInfo read.
// Re-exported so this file's importers are unchanged; not used inside this file.
export { updateFulfillmentStatusOffline } from "@rista/core/helpers/OfflineHelper";

export function transferTicketOffline(params) {
  let { ticketNumber, fromSaleId, toSaleId, toSale, cb } = params;
  const windowObj = window;
  let saleIds = [fromSaleId],
    fromSale,
    transferResult = {},
    parsedSale,
    posSettings = store.getState().businessStore?.businessData.posSettings
      || store.getState().catalogStore.posSettings;

  if (!isEmpty(toSaleId)) {
    saleIds.push(toSaleId);
  }

  fetchOfflineSale({
    saleIds,
    callback: (sales) => {
      if (isEmpty(sales)) {
        //Ext.Msg.alert('', 'Sales not found!');
        return;
      }
      sales.forEach((sale) => {
        parsedSale = JSON.parse(sale);
        if (fromSaleId && parsedSale.mid === fromSaleId) {
          fromSale = parsedSale;
        } else if (toSaleId && parsedSale.mid === toSaleId) {
          toSale = parsedSale;
        }
      });
      if (!toSale || !fromSale) {
        // Ext.Msg.alert('', 'Sales to transfer not found!');
        return;
      }
      transferResult = windowObj.RL.saleutil.transferTicket({
        fromSale: fromSale,
        toSale: toSale,
        ticketNumber: ticketNumber,
        posSettings: posSettings
      });
      if (transferResult.error) {
        // Ext.Msg.alert('', Rista.MessageUtil.getMessage(error));
        return;
      }
      fromSale = transferResult.fromSale;
      toSale = transferResult.toSale;
      fromSale = calculateAndUpdateSale(fromSale);
      toSale = calculateAndUpdateSale(toSale);
      saveSaleLocally({
        sale: fromSale,
        callback: function (returnedFromSale) {
          if (returnedFromSale.code) {
            handleOfflineError(returnedFromSale.code);
            return;
          }
          saveSaleLocally({
            sale: toSale,
            callback: function (returnedToSale) {
              if (returnedToSale.code) {
                handleOfflineError(returnedToSale.code);
                return;
              }
              if (cb) {
                cb({ fromSale: returnedFromSale, toSale: returnedToSale })
              }
            }
          });
        }
      });
    }
  });
}

export function transferItemsOffline(params) {
  const { saleItems, fromSaleId, toSale, cb } = params;
  const windowObj = window;
  let saleId = fromSaleId,
    fromSale,
    transferResult = {},
    parsedSale,
    posSettings = store.getState().businessStore?.businessData.posSettings
      || store.getState().catalogStore.posSettings;

  // if (!isEmpty(toSaleId)) {
  //     saleIds.push(toSaleId);
  // }

  const businessStore = store.getState().businessStore;
  const businessData = businessStore?.businessData;
  const userData = businessStore?.userData;

  const auditInfo = {
    date : moment().tz(businessData.timeZone.zoneId).format(),
    buid : userData.businessUserId,
    userName : {
      firstName: `${userData.name?.firstName || ''} ${userData.name?.lastName || ''}`
    },
    businessDay : windowObj.RL.saleutil.getBusinessDay(moment().tz(businessData.timeZone.zoneId).format(), businessData.transactionEnd),
    deviceIdentifier : getLocalStorage('deviceIdentifier'),
    deviceLabel : businessData?.deviceInfo?.label
  };

  fetchOfflineSale({
    saleId,
    callback: (sale, error) => {
      if (error) {
        // Rista.CommonHelper.handleOfflineError(error, cb, scope);
        handleOfflineError(error.code);
        return;
      }
      if (isEmpty(sale)) {
        // Ext.Msg.alert('', 'Sales not found!');
        return;
      }
      // sales.forEach(function (sale) {
      parsedSale = structuredClone(sale);
      if (fromSaleId && parsedSale.mid === fromSaleId) {
        fromSale = parsedSale;
      }
      //  else if (toSaleId && parsedSale.mid === toSaleId) {
      //     toSale = parsedSale;
      // }
      // });
      if (!toSale || !fromSale) {
        ToastNotifyError('Sales to transfer not found!');
        return;
      }
      transferResult = windowObj.RL.saleutil.transferSaleItems({ fromSale: fromSale, toSale: toSale, saleItems: saleItems, posSettings: posSettings, auditInfo: auditInfo });
      if (transferResult.error) {
        ToastNotifyError(Rista.MessageUtil.getMessage(error));
        return;
      }
      fromSale = transferResult.fromSale;
      //toSale = transferResult.toSale;
      fromSale = calculateAndUpdateSale(fromSale);
      transferResult.toSale = calculateAndUpdateSale(transferResult.toSale);
      saveSaleLocally({
        sale: fromSale,
        callback: function (returnedFromSale) {
          if (returnedFromSale.code) {
            handleOfflineError(returnedFromSale.code);
            return;
          }
          saveSaleLocally({
            sale: transferResult.toSale,
            callback: function (returnedToSale) {
              if (returnedToSale.code) {
                handleOfflineError(returnedFromSale.code);
                return;
              }
              if (cb) {
                cb({ fromSale: returnedFromSale, toSale: returnedToSale })
              }
            }
          });
          if (fromSale?.saleItems?.length === 0) { // cancel order if this was last item on the table
            cancelSaleOffline({ mid: fromSaleId, callback: () => { } });
          }
        }
      });
    }
  });
}

export function transferTableTicketOffline(params) {
  const windowObj = window;
  const { saleId, newResourceId, callback, cb } = params,
    businessStore = store.getState().businessStore,
    businessData = businessStore?.businessData,
    posSettings = store.getState().catalogStore?.posSettings,
    userData = businessStore?.userData,
    resources = store.getState().tableViewStore?.resources,
    resourceGroups = store.getState().tableViewStore?.resourceGroups;
  let auditInfo = {},
    resourceRec, oldResourceName, newResourceName, resourceGrpRec;

  if (isEmpty(saleId)) {
    return;
  }

  fetchOfflineSale({
    saleId,
    callback: (parsedSale) => {
      if (isEmpty(parsedSale)) {
        // Ext.Msg.alert('', 'Sales not found!');
        return;
      }
      if (parsedSale && parsedSale.serviceLabel) {
        oldResourceName = parsedSale.serviceLabel.label;
      }
      resourceRec = resources?.find((res) => res.mid === newResourceId);
      if (!resourceRec) {
        //Ext.Msg.alert('', 'Resource not found!');
        return;
      }
      if (resourceRec) {
        parsedSale.serviceLabel = {
          label: resourceRec.name,
          resourceId: newResourceId,
          resourceGroupId: resourceRec.resourceGroupId,
          count: resourceRec.capacity
        };
        newResourceName = parsedSale.serviceLabel.label;
      }
      if (resourceRec.resourceGroupId) {
        resourceGrpRec = resourceGroups?.find((resg) => resg.mid === resourceRec.resourceGroupId);
        if (resourceGrpRec) {
          parsedSale.serviceLabel.resourceGroupId = resourceRec.resourceGroupId;
          parsedSale.serviceLabel.resourceGroupName = resourceGrpRec.name;
        }
      }

      auditInfo.date = moment().tz(businessData.timeZone.zoneId).format();
      auditInfo.buid = userData.businessUserId;
      auditInfo.userName = userData.name;
      auditInfo.userId = userData.userId;
      auditInfo.transactionEnd = businessData.transactionEnd;
      auditInfo.deviceIdentifier = getLocalStorage('deviceIdentifier');
      auditInfo.deviceLabel = businessData?.deviceInfo?.label;

      let transferResult = windowObj.RL.saleutil.createTransferTickets(parsedSale, {
        audit: auditInfo,
        posSettings: posSettings,
        oldResourceName: oldResourceName,
        newResourceName: newResourceName
      });
      if (transferResult.error) {
        // Ext.Msg.alert('', Rista.MessageUtil.getMessage(error));
        return;
      }
      parsedSale = calculateAndUpdateSale(parsedSale);
      saveSaleLocally({
        sale: parsedSale,
        callback: (returnedSale) => {
          if (returnedSale.code) {
            handleOfflineError(returnedSale.code)
            return;
          }
          if (cb) {
            cb(returnedSale);
          }
          if(callback){
            callback({sale : returnedSale});
          }
        }
      });
    }
  });
}

export function splitSalePhysically(params) {
  const { sale, callback } = params;
  const calcParams = getParamsForSaleCalculate(sale);
  const windowObj = window;
  let result, count = 0

  result = windowObj.RL.saleutil.splitPhysically(structuredClone(sale), calcParams);
  if (!result) {
    handleOfflineError('ERR_UNKNOWN')
    return;
  }
  if (!isEmpty(result.code)) {
    handleOfflineError(result.code)
    return;
  }
  if (isEmpty(result.splits) || result.splits.length < 2) {
    handleOfflineError('ERR_NO_SPLITS')
    return;
  }
  for (let i = 0; i < result?.splits?.length; i++) {
    let split = result?.splits[i]
    if(!split?.mid){
    split["mid"] = ObjectID().toHexString();
    }
  }
  saveMultipleSales(result.splits, 0, callback);
}

export function saveMultipleSales(sales, count, cb) {
  var me = this;
  if (count >= sales.length) {
    if (cb) {
      cb({ splits: sales })
    }
    return;
  }
  sales[count].syncStatus = 'tobesynced';
  sales[count].operation = 'SAVE_SALE';
  sales[count] = calculateAndUpdateSale(sales[count]);
  saveSaleLocally({
    sale: sales[count],
    callback: (returnedSale) => {
      if (returnedSale.code) {
        handleOfflineError(returnedSale.code)
        return;
      }
      count++;
      saveMultipleSales(sales, count, cb);
    }
  });
}

export function changeTicketStatusOffline (params) {
  const { mid, ticketNumber, status, cb, payload } = params;
  const userData = store.getState().businessStore?.userData;
  const businessData = store.getState().businessStore?.businessData;
  const windowObj = window;
  let auditInfo = {};

  fetchOfflineSale({
    saleId : mid,
    callback: (sale) => {
      if (isEmpty(sale)) {
        // Ext.Msg.alert('', 'Sales not found!');
        return;
      }
      auditInfo.date = moment().tz(businessData.timeZone.zoneId).format();
      auditInfo.buid = userData.businessUserId;
      auditInfo.userName = userData.name;
      auditInfo.userId = userData.userId;
      auditInfo.transactionEnd = businessData.transactionEnd;
      auditInfo.deviceIdentifier = getLocalStorage('deviceIdentifier');
      sale = windowObj.RL.saleutil.updateTicketStatus({ sale: sale, ticketNumber: ticketNumber, ticketStatus: status, audit: auditInfo });
      if (sale.error) {
          handleOfflineError(sale.error);
          return;
      }
      sale.syncStatus = 'tobesynced';
      sale.operation = 'SAVE_SALE';
      sale = calculateAndUpdateSale(sale);
      saveSaleLocally({
        sale: sale,
        callback: (returnedSale) => {
          if (returnedSale.code) {
            handleOfflineError(returnedSale.code)
            return;
          }
          if (cb) {
            cb(returnedSale);
          }
        }
      });
    }
  });
}

export function cancelTicketOffline (params) {
  const { mid, ticketNumber, cb, payload } = params;
  const userData = store.getState().businessStore?.userData;
  const businessData = store.getState().businessStore?.businessData;
  const windowObj = window;
  let auditInfo = {};

  fetchOfflineSale({
    saleId : mid,
    callback: (sale) => {
      if (isEmpty(sale)) {
        // Ext.Msg.alert('', 'Sales not found!');
        return;
      }
      auditInfo.date = moment().tz(businessData.timeZone.zoneId).format();
      auditInfo.buid = userData.businessUserId;
      auditInfo.userName = userData.name;
      auditInfo.userId = userData.userId;
      auditInfo.transactionEnd = businessData.transactionEnd;
      auditInfo.deviceIdentifier = getLocalStorage('deviceIdentifier');
      auditInfo.deviceLabel = businessData?.deviceInfo?.label;
  
      sale = windowObj.RL.saleutil.cancelTicket(sale, ticketNumber,
          { 
            audit:auditInfo,
            billRoundingMode: businessData.billRoundingMode, 
            statusInfo: payload 
          });
      sale = calculateAndUpdateSale(sale);
      sale.syncStatus = 'tobesynced';
      sale.operation = 'SAVE_SALE';
      saveSaleLocally({
        sale: sale,
        callback: (returnedSale) => {
          if (returnedSale.code) {
            handleOfflineError(returnedSale.code)
            return;
          }
          if (cb) {
            cb(returnedSale);
          }
        }
      });
    }
  });
}

export function isUserHasOfflineAccess() {
  const userData = store.getState()?.businessStore?.userData || {},
    offlineUserList = store.getState().loginStore?.offlineUsers || {};
  return offlineUserList[userData?.businessUserId] ? true : false;
}

// Moved to @rista/core/helpers/OfflineHelper (a real platform split — mobile hard-codes true).
// Re-exported so this file's importers are unchanged; nothing in this file calls it.
export { isEnableOfflineModeFeature } from "@rista/core/helpers/OfflineHelper";


// Moved to @rista/core/helpers/OfflineHelper. `validateAndSaveSale` is in shared.ts; the other
// five are PER-VARIANT (this platform differs on the clone function, on the default syncStatus
// of a sale that has none, on whether initiatedBy carries a device identifier, on the shape of
// statusInfo, and on whether a missing sale toasts). All six are IMPORTED as well as
// re-exported: this file calls them in its own body (hazard 30 — and this is a .js file, so
// nothing but that grep would catch it).
//
// The module-private `processSalePreorders` went with them and is NOT re-exported: it was
// private here too, and core keeps it private in shared.ts.
export {
  saveSaleOffline,
  saveSaleLocally,
  fetchOfflineSale,
  cancelSaleOffline,
  voidSaleOffline,
  validateAndSaveSale,
} from "@rista/core/helpers/OfflineHelper";
import {
  saveSaleLocally,
  fetchOfflineSale,
  cancelSaleOffline,
  validateAndSaveSale,
} from "@rista/core/helpers/OfflineHelper";

export function updateTicketPrintStatus(params) {
  const {
    id,
    ticketInfos: [{ ticketNumber, printStatus }],
    sync = true,
    cb,
    printSource,
  } = params;

  fetchOfflineSale({
    saleId: id,
    callback: (sale, error) => {
      console.log(
        "===============ticketGroup updateTicketPrintStatus sale---------",
        sale,
        params
      );
      if (error) {
        handleOfflineError(error);
        return;
      }
      if (!sale) {
        ToastNotifyError("Sale not found!");
        return;
      }
      //sale = JSON.parse(sale);
      if (!isEmpty(ticketNumber)) {
        sale.tickets.forEach(function (saleTicket) {
          if (saleTicket.ticketNumber === ticketNumber) {
            saleTicket.printStatus = printStatus;
            if (
              saleTicket.printStatus === TICKET_PRINT_STATUS_TYPES.COMPLETED
            ) {
              saleTicket.printed = true;
            }
          }
        });
      }
      if (sync) {
        sale.syncStatus = SALE_SYNC_STATUSES.TO_BE_SYNCED;
        sale.operation = SALE_PROCESS_OPERATION_TYPES.SAVE_SALE;
      }
      saveSaleLocally({
        sale,
        callback: (returnedSale) => {
          console.log(
            "===============ticketGroup updateTicketPrintStatus returnedSale---------",
            returnedSale
          );
          if (returnedSale.code) {
            handleOfflineError(returnedSale.code);
            return;
          }
          if (cb) {
            cb(returnedSale);
          }
        },
        source: printSource,
      });
    },
  });
}


// switches app to offline mode if there are unsynced sales
// returns synced sales which are outdated. also returns
// if there are any unsynced sales
// clears orders saved in index db after a specified time
export function getSaleTicketsToPrintOffline(cb, ecb) {
  get({
    domain: "SALE",
    filter: {
      name: "SALES_WITH_UNPRINTED_TICKETS",
      params: {
        posSettings: store.getState().catalogStore?.posSettings || {},
      },
    },
    callbackFn: (sales, error) => {
      if (error) {
        handleOfflineError(error);
        ecb?.(error);
        return;
      }
      let filteredSales = [];
      if (!isEmpty(sales)) {
        filteredSales = sales.map(function (sale) {
          return JSON.parse(sale);
        });
      }
      cb(filteredSales);
    },
  });
}

// Moved to @rista/core/helpers/OfflineHelper.
//   shared.ts        -> fetchAllOfflineSales, removeOfflineSale (byte-identical in both apps)
//   index.desktop.ts -> checkOfflineOperatedSales plus its two module-private helpers
//                       (filterOutdatedSyncedSales, syncUncsyncedSales). All three are web-only —
//                       the other platform has no such functions at all.
// Session 26 deferred this closure; it landed once the login saga needed it.
export {
  fetchAllOfflineSales,
  removeOfflineSale,
  checkOfflineOperatedSales,
} from "@rista/core/helpers/OfflineHelper";
